




































































import "./plan.less";
import Vue from "vue";
import Util from "./../../lib/util";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import PricePlan from "../../store/entities/price-plan";

export default Vue.extend({
  name: "ServicePanel",
  data() {
    return {};
  },
  computed: {
    ...mapState("billing", ["loading", "billingAccount", "pricePlans"]),
    plans() {
      let context = this as any;
      let interval = context.currentPlan ? context.currentPlan.interval : "year";
      return context.pricePlans && context.pricePlans.length > 0 ? context.pricePlans.filter((p) => p.interval === interval) : [];
    },
    currentPlan() {
      let context = this as any;
      let plans = context.pricePlans && context.pricePlans.length > 0 ? context.pricePlans.filter((p) => p.priceId === context.billingAccount.currentPlanId) : [];
      return plans.length > 0 ? plans[0] : null;
    },
    assignedQuantity() {
      let context = this as any;
      return context.billingAccount.members.filter((m) => m.licenseAssigned === true).length;
    },
    notAssignedQuantity() {
      let context = this as any;
      return context.billingAccount ? context.billingAccount.licenseQuantity - context.assignedQuantity : 0;
    },
    activeWithoutCancel() {
      let context = this as any;
      return context.billingAccount.cancelAt === null && (context.billingAccount.status === 3 || context.billingAccount.status === 6);
    },
    willBeCanceled() {
      let context = this as any;
      return context.billingAccount.cancelAt !== null;
    },
    willBeCanceledAt() {
      let context = this as any;
      return context.billingAccount.cancelAt !== null ? moment(context.billingAccount.cancelAt).format("L") : "";
    },
  },
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$store
        .dispatch("billing/getPricePlans")
        .then((response) => {})
        .finally(() => {});
    },
    getPrice(plan) {
      let context = this as any;
      let tiers = plan.priceTiers.filter((t) => t.quantityUpTo >= context.billingAccount.licenseQuantity);
      if (plan.interval === "month") {
        return tiers.length > 0 ? tiers[0].flatCost / 100 : "";
      } else {
        return tiers.length > 0 ? Math.round(tiers[0].flatCost / 100 / 12) : "";
      }
    },
  },
});
